<template>
  <footer>
    <!-- Seção Superior: Logo e Redes Sociais -->
    <v-row no-gutters>
      <v-col class="text-left" cols="6">
        <a :href="linkTigre" class="text-decoration-none" target="_blank">
          <img src="@/assets/images/tigre.svg" alt="Tigre" />
        </a>
      </v-col>

      <v-col class="text-right" cols="6">
        <p class="text-uppercase">ACOMPANHE A TIGRE:</p>
        <div class="d-flex justify-end align-center">
          <a :href="linkFacebook" target="_blank" class="social-icon mx-2">
            <img
              src="@/assets/images/Facebook.svg"
              alt="Facebook"
              class="social-icon-img"
            />
          </a>
          <a :href="linkTwitter" target="_blank" class="social-icon mx-2">
            <img
              src="@/assets/images/Twitter.svg"
              alt="Twitter"
              class="social-icon-img"
            />
          </a>
          <a :href="linkYoutube" target="_blank" class="social-icon mx-2">
            <img
              src="@/assets/images/Youtube.svg"
              alt="YouTube"
              class="social-icon-img"
            />
          </a>
          <a :href="linkLinkedin" target="_blank" class="social-icon mx-2">
            <img
              src="@/assets/images/Linkedin.svg"
              alt="LinkedIn"
              class="social-icon-img"
            />
          </a>
          <a :href="linkInstagram" target="_blank" class="social-icon mx-2">
            <img
              src="@/assets/images/Instagram.svg"
              alt="Instagram"
              class="social-icon-img"
            />
          </a>
        </div>
      </v-col>
    </v-row>
    <div class="separator"></div>

    <!-- Layout para Desktop (colunas) -->
    <v-row v-if="!display.mdAndDown.value">
      <v-col
        v-for="(link, index) in linksRodape"
        :key="index"
        class="text-left"
      >
        <h6 class="text-uppercase">{{ link.titulo }}</h6>
        <ul>
          <li v-for="(subLink, subIndex) in link.links" :key="subIndex">
            <a
              v-if="subLink.url"
              :href="subLink.url"
              class="text-decoration-none"
            >
              {{ subLink.nome }}
            </a>
            <span v-else>
              {{ subLink.nome }}
            </span>
            <div v-if="subLink.subnome" class="subnome">
              {{ subLink.subnome }}
            </div>
          </li>
        </ul>
      </v-col>
    </v-row>

    <!-- Layout para Mobile (acordeão atualizado) -->
    <div v-else class="custom-accordion">
      <div
        v-for="(link, index) in linksRodape"
        :key="index"
        class="accordion-item"
      >
        <div
          class="accordion-title"
          @click="!link.open && togglePanel(index)"
          style="user-select: none"
        >
          <span class="title-text">{{ link.titulo }}</span>
          <v-icon
            v-if="!link.open"
            class="accordion-icon"
            :class="{ 'rotate-up': expandedPanels.includes(index) }"
          >
            mdi-chevron-down
          </v-icon>
        </div>

        <div
          v-show="link.open || expandedPanels.includes(index)"
          class="accordion-content"
        >
          <ul>
            <li
              v-for="(subLink, subIndex) in link.links"
              :key="subIndex"
              class="footer-item"
            >
              <a
                v-if="subLink.url"
                :href="subLink.url"
                class="text-decoration-none"
                target="_blank"
              >
                {{ subLink.nome }}
              </a>
              <span v-else>{{ subLink.nome }}</span>

              <div v-if="subLink.subnome" class="subnome">
                {{ subLink.subnome }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="faq">
      <div class="faq-links">
        <a
          href="https://www.tigre.com.br/termos"
          class="text-faq-termo"
          target="_blank"
        >
          Termos de Uso
        </a>
        <a
          href="https://www.tigre.com.br/politica-de-privacidade"
          class="text-faq-politica"
          target="_blank"
        >
          Política de Privacidade
        </a>
        <a
          href="https://www.tigre.com.br/perguntas-frequentes"
          class="text-faq-faq"
          target="_blank"
        >
          FAQ
        </a>
      </div>
      <span class="text-faq-copy">2024 © Tigre S/A</span>
    </div>
  </footer>
</template>

<script setup>
import { useDisplay } from "vuetify";
import { ref } from "vue";

const linksRodape = [
  {
    titulo: "Grupo Tigre",
    open: false,
    links: [
      { nome: "Quem somos", url: "https://www.tigre.com.br/quem-somos" },
      {
        nome: "ICRH",
        url: "https://www.tigre.com.br/instituto-carlos-roberto-hansen",
      },
      {
        nome: "Tigre na Mídia",
        url: "https://www.tigre.com.br/tigre-na-midia",
      },
      { nome: "Exportação", url: "https://www.tigre.com.br/exportacao" },
      {
        nome: "Sustentabilidade",
        url: "https://www.tigre.com.br/sustentabilidade",
      },
      { nome: "Relações com Investidores", url: "https://ri.tigre.com.br/" },
    ],
  },
  {
    titulo: "Nossos Produtos",
    open: false,
    links: [
      {
        nome: "Obras e Reformas",
        url: "https://www.tigre.com.br/produtos/obras-e-reformas",
      },
      {
        nome: "Ferramentas para Pintura",
        url: "https://www.tigre.com.br/produtos/ferramentas-para-pintura",
      },
      {
        nome: "Infraestrutura",
        url: "https://www.tigre.com.br/produtos/infraestrutura",
      },
      {
        nome: "Água e Efluentes",
        url: "https://www.tigre.com.br/tigre-aguas-e-efluentes",
      },
      {
        nome: "Industrial",
        url: "https://www.tigre.com.br/produtos/industrial",
      },
      { nome: "Irrigação", url: "https://www.tigre.com.br/produtos/irrigacao" },
    ],
  },
  {
    titulo: "Tigre Para Você",
    open: false,
    links: [
      { nome: "Carreiras", url: "https://www.tigre.com.br/carreiras" },
      {
        nome: "Materiais Técnicos",
        url: "https://www.tigre.com.br/catalogos-tecnicos",
      },
      { nome: "EducaTigre", url: "https://www.tigre.com.br/educatigre" },
      {
        nome: "Juntos Somos +",
        url: "https://www.tigre.com.br/juntos-somos-mais",
      },
      { nome: "Tigre BIM", url: "https://www.tigre.com.br/tigre-bim" },
    ],
  },
  {
    titulo: "Atendimento",
    open: true,
    links: [{ nome: "Contato", url: "https://www.tigre.com.br/contato" }],
  },
  {
    titulo: "Telefones",
    open: false,
    links: [
      { nome: "Assistência Técnica", subnome: "0800 707 4700" },
      { nome: "Assistência Comercial", subnome: "0800 707 4900" },
      { nome: "Assistência ao Profissional", subnome: "0800 707 4900" },
    ],
  },
  {
    titulo: "Canal de Ética",
    open: true,
    links: [{ subnome: "0800 602 1350" }],
  },
];

const expandedPanels = ref(
  linksRodape
    .map((item, index) => (item.open ? index : null))
    .filter((index) => index !== null)
);

function togglePanel(index) {
  if (linksRodape[index].open) return;

  if (expandedPanels.value.includes(index)) {
    expandedPanels.value = expandedPanels.value.filter((i) => i !== index);
  } else {
    expandedPanels.value.push(index);
  }
}

const display = useDisplay();

const linkTigre = import.meta.env.VITE_LINK_TIGRE || "https://www.tigre.com.br";
const linkFacebook =
  import.meta.env.VITE_LINK_FACEBOOK || "https://www.facebook.com/TigreBrasil";
const linkInstagram =
  import.meta.env.VITE_LINK_INSTAGRAM ||
  "https://www.instagram.com/tigrebrasil/";
const linkLinkedin =
  import.meta.env.VITE_LINK_LINKEDIN ||
  "https://www.linkedin.com/company/tigre";
const linkYoutube =
  import.meta.env.VITE_LINK_YOUTUBE || "https://www.youtube.com/tigre";
const linkTwitter = import.meta.env.VITE_LINK_TWITTER || "https://x.com/tigre";
</script>

<style lang="scss">
footer {
  background: $gradient-primary;
  width: 100%;
  font-family: "Ubuntu", sans-serif;
  color: $text-light;
  padding: 24px 100px 32px 100px;

  .v-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .separator {
    height: 1px;
    background: $gradient-separator;
    width: calc(100% + 200px);
    margin-left: -100px;
    margin-right: calc(-16px);
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .v-col {
    min-width: 150px;

    h6 {
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 16px 0 0 0;

      li {
        margin: 16px 0 0 0;
        a,
        span {
          font-size: 14px;
          color: $text-light;
          display: block;
        }

        .subnome {
          font-size: 14px;
          opacity: 0.9;
        }
      }
    }
  }

  .social-icon {
    display: inline-block;

    .social-icon-img {
      width: 24px;
      height: 24px;
    }
  }

  p {
    text-transform: uppercase;
    color: $text-light;
  }

  .custom-accordion {
    .accordion-item {
      margin-bottom: 38px;
      .accordion-title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        font-weight: 600;
        text-transform: uppercase;
        color: $text-light;

        .title-text {
          font-size: 16px;
        }

        .accordion-icon {
          font-size: 20px;
          transition: transform 0.3s ease;
          margin-left: 8px;
        }

        .rotate-up {
          transform: rotate(180deg);
        }
      }

      .accordion-content {
        margin-top: 8px;

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-top: 8px;

            a,
            span {
              font-size: 14px;
              color: $text-light;
              display: block;
            }

            .subnome {
              font-size: 14px;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1200px) {
    padding: 32px 16px 0 16px !important;
    margin: 0 !important;

    .separator {
      width: calc(100% + 32px) !important;
      margin-left: -16px !important;
    }
    .v-row {
      .v-col.text-left,
      .v-col.text-right {
        flex-basis: 100%;
        max-width: 100%;
        text-align: center !important;
        margin-bottom: 10px;
      }
      .d-flex.justify-end {
        justify-content: center !important;
      }
    }

    .faq {
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 16px;
      margin: 32px -16px -16px -16px;

      .faq-links {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      span.text-faq-copy {
        margin-top: 12px;
        display: block;
        width: 100%;
        text-align: center;
      }
    }
  }
}

.faq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 80px;
  background-color: #ffffff;
  color: #636463;
  margin: 32px -100px -32px -100px;
  font-size: 14px;
  font-weight: 400;
  font-family: "Ubuntu", sans-serif;
}
.faq a,
.faq span {
  color: #636463;
  margin: 8px 16px;
  text-decoration: none;
}
.faq span {
  margin-left: auto;
}
</style>
